/* tslint:disable:max-line-length*/
let Enums = {
  BUG: {
    type: 'Bug',
    icon: 'bug_report',
  },
  FEATURE_REQUEST: {
    type: 'Feature request',
    icon: 'lightbulb_outline',
  },
  CONFUSING: {
    type: 'Confusing',
    icon: 'live_help',
  },
  WORK_IN_PROGRESS: {
    type: 'In progress',
    icon: 'update',
  },
  NEW_FEATURE: {
    type: 'New feature',
    icon: 'new_releases',
  },
  BUG_FIX: {
    type: 'Bugfix',
    icon: 'done',
  },
  UI_CHANGE: {
    type: 'UI change',
    icon: 'done',
  },
};

// TODO: These should be moved to its own constant

// This array populates the top part of the changelog
let inProgress = [
  {
    type: Enums.BUG.type,
    icon: Enums.BUG.icon,
    description: `Dashboard Bugs:
    <ul>
      <li>When filtering on a percentage value in the grid, you must use a decimal point</li>
      <li>You can't currently select an empty value (E.g. no value) when editing a single cell in the grid</li>
      <li>Sometimes extra space gets added above the visualizations</li>
      <li>Not all menu options always show up in the three dot menu for Regents Planning & Prep.  
      For now, refresh the page to correct the issue</li>
      <li>Can’t select empty value when editing a single cell</li>
      <li>Grid resorts on every single cell edit</li>
    </ul>`,
  },
  {
    type: Enums.BUG.type,
    icon: Enums.BUG.icon,
    description: `Student Profile Bugs:
    <ul>
      <li>Full Transcript History Panel: Course Code column is displaying DBN instead of Course Code</li>
      <li>Multiple known issues related to assigning supports from the Regents Panel and Assigned Supports panels</li>
    </ul>`,
  },
  {
    type: Enums.WORK_IN_PROGRESS.type,
    icon: Enums.WORK_IN_PROGRESS.icon,
    description: 'Ability to create a new note and attach to either a student or a student support',
  },
  {
    type: Enums.WORK_IN_PROGRESS.type,
    icon: Enums.WORK_IN_PROGRESS.icon,
    description: `Design for <a target='_blank' href='https://www.evernote.com/shard/s391/sh/10365470-37fa-41d1-8986-ef6643d21180/8e0e35a45f1d6452e758f5bbfcd5173f'>Credit Gaps Panel</a>`,
  },
];

// This is the full changelog history
// Completed items should be nested within a releaseDate array
let changelog = [
  {
    releaseDate: '12.02.2016',
    items: [
      {
        type: Enums.NEW_FEATURE.type,
        icon: Enums.NEW_FEATURE.icon,
        description: `In Dashboard
        <ul>
          <li><a target='_blank' href='https://www.evernote.com/l/AYc-YE6twqpKmJs31P69dSybCDfDDSY9yOM'>Simplified Grad Planning visualizations</a> to make it easier to target students missing graduation plans.  <a target='_blank' href='https://www.evernote.com/l/AYeIIb-P4FlIiZ9a4MPmoZt0br4tl7ZSgvE'>Filter for a cohort to view Planned June and August Graduation Outcomes.</a></li>
          <li><a target='_blank' href='https://www.evernote.com/l/AYegVpefSglKx79bdGBIEjuJdbHhvj14twU'>Added a Regents Prep Wizard</a>, which highlights students scheduled for exams in the upcoming administration who are missing prep.</li>
          <li>Enhanced the Student Report Template.  <a target='_blank' href='https://www.evernote.com/l/AYf5KUmufipGsZVjPJCVeTcsuIB7Zmi7-mA'>View a sample report here!</a>  Generate hundreds of Student Reports in <a target='_blank' href='https://www.evernote.com/shard/s391/sh/839751ba-5eac-412c-8794-fbdc36931701/184f64cdbf9ca53f3fb1ffbb04f1352b'>just seconds.</a></li>
        </ul>
        <p>In Student Profile</p>
        <ul>
          <li>Added the ability for you to <a target='_blank' href='https://www.evernote.com/l/AYfhL74Q3pBKSLOIeXYXLz4liTWWD2QousQ'>generate a student report for a the active student</a>.</li>
        </ul>`,
      },
    ],
  },
  {
    releaseDate: '11.10.2016',
    items: [
      {
        type: Enums.NEW_FEATURE.type,
        icon: Enums.NEW_FEATURE.icon,
        description: `<p>Added ability to export Student Profile's as PDF reports.
            <br><i>Click the gear icon after selecting students in the grid</i>
          </p>`,
      },
      {
        type: Enums.BUG_FIX.type,
        icon: Enums.BUG_FIX.icon,
        description: `<p>Regents Planning Wizard
            <br> - Filters now calculating correctly on load
            <br> - Each step has a blue "SELECT ALL" button that correctly selects students in the grid
            <br> - Each step has a "CLEAR ALL" button that clears all selected students
            <br> - Navigating from step to step changes the filter
            <br> - The filter(s) specific to the wizard step are locked, meaning they cannot be changed or removed by the user when in the wizard
            <br> - The grid toolbar button to clear filters does not allow you to clear locked filters
            <br> - Changing the selected regents exam brings the user back to the first step and refetches the grid columns with the data relevant to that exam.
            <br>
          </p>`,
      },
      {
        type: Enums.BUG_FIX.type,
        icon: Enums.BUG_FIX.icon,
        description: `<p>Student Supports
          <br> - Are now loading up correctly when the Single Student View originally loads
          <br> - Are added correctly when added from the Single Student View button
        </p>`,
      },
      {
        type: Enums.NEW_FEATURE.type,
        icon: Enums.NEW_FEATURE.icon,
        description: 'Added changelog page to keep users up-to-date on portal progress!',
      },
    ],
  },
];

angular.module('nv.routes.main').config(changelogConfigBlock);

function changelogConfigBlock($stateProvider) {
  $stateProvider.state('main.changelog', {
    url: '/changelog/:schoolId',
    template: require('../../features/changelog/changelog.html'),
    resolve: {
      currentSchool($stateParams, School) {
        let currentSchool = new School({ _id: $stateParams.schoolId });
        return currentSchool.$get().then(function() {
          return currentSchool;
        });
      },
    },
    controller($scope, currentSchool, currentUser) {
      $scope.currentSchool = currentSchool;
      $scope.inProgress = inProgress;
      $scope.changelog = changelog;
      $scope.currentUser = currentUser;
    },
  });
}
